var indentation_default = {
  "indentZero": "w-9wI",
  "indentOne": "ERElk",
  "indentTwo": "TZpeO",
  "indentThree": "_4sDyH",
  "indentFour": "R7OJf",
  "indentFive": "VDkS2",
  "indentSix": "bcoBs"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
